export * from './axios';
export { errorHandler, getErrorCode } from './errorHandler';
export * from './getEnvValue';
export * from './kratosIntegration';
export { retrieveKratosErrors } from './retrieveKratosErrors';
export * from './sendRequest';
export * from './transformArrayToSearchParams';
export * from './transformPaginationToSearchParams';
export * from '../../../web/src/components/organisms/data-grid/transformSortingToSearchParams';
export * from './types';

export enum RequestMethod {
  POST = 'post',
  PATCH = 'patch',
  GET = 'get',
  DELETE = 'delete',
  PUT = 'put'
}

type RequestPath = `/${string}`;

export interface AxiosGETRequest {
  method: RequestMethod.GET;
  path: RequestPath;
  cacheKeys: string[];
}

export interface AxiosMutationRequest {
  method: RequestMethod.POST | RequestMethod.PATCH | RequestMethod.DELETE | RequestMethod.PUT;
  path: RequestPath;
}

export type AxiosRequest = AxiosGETRequest | AxiosMutationRequest;
